import React, { useEffect, useState } from 'react';
import BreadCrumb from '../../../components/breadcrumb/BreadCrumb';
import style from '../kpi.module.scss'
import PowerBi from '../../../components/powerbi/PowerBi';
import * as utils from '../../../utils/utils';
import * as favUtils from '../../../utils/favorite.utils';
import { Spin } from 'antd';

const History = props => {
    const favInput = JSON.parse(JSON.stringify(props.favInput));
    let [FavoriteId, setFavoriteId] = useState(null)
    const [loading, setLoading] = useState(false)
    const [region] = useState(JSON.parse(sessionStorage.getItem("selectedRegion")));//EMEA Release- 
    const { selectedSubRegion,selectedStrategicAccount } = props;//added for EMEA release
    const breadCrumb = [...props.breadCrumb, {
        value: 'History',
        path: "/",
    }]

    const goBack = () => {
        props.history.push('/dashboard/childview')
    };

    async function getFavorites() {
        const favorites = await favUtils.getFavorites()
        props.setFavorite(favorites)
    }

    async function addToFavorite(isAlreadyFavorite) {
        try {
            setLoading(true)
            if (!isAlreadyFavorite) {
                favInput.UserId = utils.getUserEmail()
                favInput.ViewType = 5
                favInput.region = region; //Added for EMEA release
                favInput.InputParameters.productDivision = props.selectedProductDivision;
                favInput.InputParameters.customer = props.selectedCustomer;
                favInput.InputParameters.sbs = props.selectedSBS;
                favInput.InputParameters.sasParent = props.sasParent;
                favInput.InputParameters.cxScoreDetails = props.cxScoreDetails;
                favInput.InputParameters.breadcrumb = props.breadCrumb;
                favInput.InputParameters.kpi = props.selectedKPI;
                favInput.InputParameters.subregion = selectedSubRegion;//added for EMEA release
                favInput.InputParameters.strategicAccts = selectedStrategicAccount;//added for strategic account release
                favInput.InputParameters.group.company_region = region;//added for EMEA release
                favInput.InputParameters.kpi.company_region = region;//added for EMEA release
                /*if(Object.keys(props.cxScoreDetails).length>0 && Object.keys(props.selectedKPI).length>0){//added for EMEA release
                    favInput.InputParameters.group.company_region = favInput.InputParameters.cxScoreDetails.company_region;
                    favInput.InputParameters.kpi.company_region = favInput.InputParameters.cxScoreDetails.company_region;
                }*/
                const FavoriteId = await favUtils.addFavorites(favInput)
                setFavoriteId(FavoriteId)
            } else {
                await favUtils.removeFavorites(FavoriteId)
                setFavoriteId(null)
            }
            setLoading(false)
            getFavorites()
        } catch (err) {
            console.log(err);
            setLoading(false)
        }
    }

    useEffect(() => {
        setFavoriteId(favUtils.chkIsFavorite(
            props.favorites,
            region,//added for EMEA release
            5,
            props.selectedProductDivision,
            props.selectedCustomer,
            props.selectedSBS,
            props.selectedKPI,
            '',
            selectedSubRegion,
            selectedStrategicAccount
        ))
    }, [])

    return (
        <Spin spinning={loading}>
            <div className={style.primarycontainer}>
                <BreadCrumb
                    list={breadCrumb}
                    {...props}
                    addToFavorite={addToFavorite}
                    isFavorite={FavoriteId ? true : false} />
                <div className={style.layoutbx}>
                    <div className={style.childheading}>
                        <div className={style.backBtn} onClick={goBack}>Back</div>
                        <div className={style.resetBtn} onClick={utils.resetPBIView}>Reset</div>
                        <span className={style.childheadingtext}>
                        </span>
                    </div>
                    <PowerBi view={props.selectedKPI.history} height="700px" />
                </div>
            </div>
        </Spin>
    );
}

export default History

